import React from 'react';

import { Div } from 'nexcomponent-ui';

import { mainBreadCrumb } from '../../../../Enum/Breadcrumb/CommonBreadcrumb';
import { divisionColumn } from '../../../../Enum/Column/DivisionColumn';
import { MAPPING_CODE } from '../../../../Enum/MappingCode/MappingCode';
import {
  ROUTER_CONSTANT,
} from '../../../../Enum/RouterConstant/RouterConstant';
import {
  fetchDataDivisionList,
  fetchDivisionMappingForm,
} from '../../../../Fetch/FetchData/DivisionData';
import HeaderPageList
  from '../../../Organisms/Header/HeaderPageList/HeaderPageList';
import MappingList from '../../../Organisms/TableList/MappingList/MappingList';

const DivisionPage = props => (
  <Div>
    <HeaderPageList
      notify={props.notify}
      t={props.t}
      dispatch={props.dispatch}
      navigate={props.navigate}
      listBreadcrumb={mainBreadCrumb(props.t)}
      toTitlePage={ROUTER_CONSTANT.INDEX}
      title={props.t("DIVISION:TITLE")}
      mappingCode={MAPPING_CODE.DIVISION}
      defaultBreadcrumb={props.t("DIVISION:TITLE")}
      rejectNavigate={ROUTER_CONSTANT.DIVISION.REJECT_REASON}
      uniqueKey="division_id"
      mappingNavigate={(NewId, ExistId, List) =>
        fetchDivisionMappingForm(
          props.validToken(),
          props.dispatch,
          "division_id",
          NewId,
          ExistId,
          List,
          props.notify,
          () => props.navigate(ROUTER_CONSTANT.DIVISION.MAPPING)
        )
      }
    />
    <MappingList
      t={props.t}
      column={divisionColumn(props.t)}
      mappingCode={MAPPING_CODE.DIVISION}
      validToken={props.validToken}
      dispatch={props.dispatch}
      navigate={props.navigate}
      notify={props.notify}
      listFunc={(totalRow, countData, token, currentPage, rowLimit, sortDate, dispatch, notify) =>
        fetchDataDivisionList(
          totalRow,
          countData,
          token,
          currentPage,
          rowLimit,
          sortDate,
          dispatch,
          notify
        )
      }
    />
  </Div>
);

export default DivisionPage;
